import { connect } from 'react-redux';
import { cancelFapiao } from '../actions';
import CancelFapiaoLink from './CancelFapiaoLink';
var mapStateToProps = function mapStateToProps(state, _ref) {
  var fapiao = _ref.fapiao;
  return {
    fapiao: fapiao
  };
};
var mapDispatchToProps = {
  cancelFapiao: cancelFapiao
};
export default connect(mapStateToProps, mapDispatchToProps)(CancelFapiaoLink);